import React from "react";
import { useSelector } from "react-redux";

import ReactTableWrapper from "../../../../../common/ReactTableWrapper/ReactTableWrapper";
import Backdrop from "../../../../../UI/Backdrop/Backdrop";
import { androidPluginDeletedFiles } from "../../../../../../utils/constants/tableHeaders";

const AndroidPluginDeletedFiles = ({ report = false }) => {
  const androidPlugins = useSelector((state) => state.android.plugins);
  const isAndroidPluginsLoading = useSelector((state) => state.android.pluginsLoading);

  return (
    <div className="border">
      <Backdrop show={isAndroidPluginsLoading} absolute={true} />
      {!isAndroidPluginsLoading && (
        <ReactTableWrapper
          data={androidPlugins["DeletedFiles"] || []}
          tableName={"Deleted Files"}
          columns={androidPluginDeletedFiles}
          // exportFile={!report}
          paginationButtons
          customPageSize={10}
          // tableRef={overviewRef}
          // leftAction
          // renderRowSubComponent={!report && Details}
          // minHeight={"585px"}
          // tableFolder={"analysisReports"}
        />
      )}
    </div>
  );
};

export default AndroidPluginDeletedFiles;
